
import { Tooltip } from "@components/Tooltip";

const LongTextCell = ({ value }: any) => {
	const text = value ?? '';
	const isLong = text.length > 100;
	const normalized = isLong ? text.substring(0, 100) + '...' : text;
	return <div>
		{isLong ? <Tooltip
			normalWs={true}
			toolTipClasses={'z-999 cursor-pointer text-xs'}
			withIcon={false}
			position={"bottom"}
			text={text}
			children={<span className="text-xs">{normalized}</span>}
		/>
			: <span className="text-xs">{normalized}</span>}
	</div>;
}

export default LongTextCell